export default {
  stringNotNullOrEmpty(value: string) {
    if (value == null || value.length === 0)
      throw Error('Invariant: String not empty not satisfied.')
  },

  notNull<T>(value: T) {
    if (value == null) throw Error('Invariant: Value not null not satisfied.')
  },

  arrayNotNullOrEmpty<T>(value: T[]) {
    if (value == null || value.length == 0)
      throw Error('Invariant: Array not null or empty not satisfied.')
  },

  greaterThanZero(value: number) {
    if (value <= 0) throw Error('Invariant: Value > 0 not satisfied.')
  },

  greaterThanOrEqualZero(value: number) {
    if (value < 0) throw Error('Invariant: Value >= 0 not satisfied.')
  },

  greaterOrEqual(min: number, value: number): void {
    if (value < min) throw Error('Invariant: Value < Min not satisfied.')
  },
}
